import DensityPicker from './density-picker';
import PreviewSizePicker from './preview-size-picker';

export default function GridConfigOptions() {
	return (
		<>
			<DensityPicker />
			<PreviewSizePicker />
		</>
	);
}
